(ns web3.screens.files
  (:require-macros [cljs.core.async.macros :refer [go]])
  (:require [clojure.spec.alpha :as s]
            [cljs.core.async :refer [<!]]
            [re-frame-simple.db :as db]
            [web3.log :as log]
            [web3.components.card :as card]
            [web3.components.h-slider :as h-slider]
            [web3.components.tabs :as tabs]
            [web3.components.widgets :as widgets]
            [web3.queries.asset :as q-asset]
            [web3.screens.asset :as asset]
            [web3.screens.content :as content]
            [web3.i18n :as i]
            [web3.routing.core :as routing]
            [web3.view :as v]
            [web3.log :as log]
            [web3.persistence.schema :as schema]
            [web3.modals.forms :as forms]
            [web3.persistence.current-property :as current-property]
            [web3.routers.app-helpers :as app-route]))

;; ========== Helpers ==========


(defn content-collection
  "Returns :files/collection key for a content entity"
  [{:keys [curated category]}]
  (if curated
    :files/manuals
    (->> (dissoc schema/collection-categories
                 :files/manuals)
         (filter #(get (second %) category))
         ffirst)))

(defn collection-index
  [collection]
  (let [collection (cond->> collection
                            (string? collection) (keyword "files"))]
    (get (zipmap schema/file-collections
                 (range))
         collection)))

(defn prev-index
  []
  (log/println ::prev-index (:props (v/prev)))
  (-> (v/prev)
      (get-in [:props :collection])
      (schema/file-collection-key)
      (collection-index)))

(defn created-time
  [{:keys [createdAt]}]
  (.getTime (js/Date. createdAt)))

;; ========== Queries ==========

(defn section
  [collection query]
  {:key collection
   :title (i/get collection)
   :query query
   :contents (-> query
                 (get-in [:entity :contents])
                 (->> (remove (comp :sample :parent))
                      (sort-by created-time)))})

(defn collection-content
  [collection]
  (let [collection-key (schema/file-collection-key collection)
        categories (get schema/collection-categories collection-key)
        property-id (current-property/get-id)]
    (assert categories (str "missing ContentCategory set for" collection-key))
    (-> (doall
         (for [category categories]
           (->> {:id property-id
                 :category category
                 :curated (= :files/manuals collection-key)
                 :typeName "Property"}
                q-asset/entity-content-recursive
                (section (keyword "files" category))))))))

(defn all-items
  [property-id]
  (let [{:keys [entity]
         :as query} (q-asset/all-assets {:id property-id})]
    [{:key "items"
      :title (i/get :files/item)
      :query query
      :contents (->> entity
                     :assetGroups
                     (mapcat :assets)
                     (remove :sample)
                     (sort-by created-time))}]))

(defn contents-sections
  [{:keys [property-id
           collection]}]
  (if (= "items" collection)
    (all-items property-id)
    (collection-content collection)))

;; ========== Mutations ==========

(defn create-content!
  [this content]
  (-> content
      (merge {:curated false})
      (q-asset/content-create! {:component
                                this
                                :refetch
                                [q-asset/entity-content-recursive]
                                :on-error
                                (fn [res]
                                  (log/log "error" res))
                                :on-complete
                                (fn [x]
                                  (forms/swap-state!
                                    assoc
                                    :add/end-confirm-props
                                    (-> x
                                        (js->clj :keywordize-keys true)
                                        :data
                                        :content_create))
                                  (db/dispatch [:routing/nav (app-route/add-end-href)]))})))

;; ========== Upload File ==========

(defn field-props
  [state k]
  {:change-value! (fn [value]
                    (forms/swap-state! assoc-in [::data k] value))
   :value (get-in (forms/state) [::data k])
   :dirty? (:dirty? @state)})

;; ========== Content by Category ==========

(v/defview content-grid
  [{:keys [property-id
           collection
           key
           title
           query
           contents]
    :as props}]
  (let [edit? (routing/get-query [:edit key])
        min-card-count (max (inc (count contents))
                            (count contents))
        items? (= "items" collection)
        notes? (= "notes" collection)
        cards (->> contents
                   (mapv (fn [content]
                           (let [view (if items?
                                        asset/asset-card-props
                                        content/content-card)]
                             (view (merge content
                                          {:edit? edit?}
                                          (when notes?
                                            {:notes-grid? true})))))))]
    [card/card-grid
     (merge (if items?
              card/item-grid-props
              (if notes?
                card/notes-grid-props
                card/file-grid-props))
            {:class "margin-bottom-4"
             :add-card-props
             (when (not= "manuals" collection)
               {:href (routing/path-for
                       (cond
                         items?             [:add/asset]
                         (some? collection) [:add/file-by-collection :collection collection]
                         :else              [:add/file]))
                :label (i/get (keyword "i" (str "add-" collection)))})}
            {:min-card-count min-card-count
             :before
             [:div.flex-none.width-100p.flex.flex-column.items-stretch.pad-h-1
              [card/group
               (when title
                 [:span.text-category.pad-v-2
                  title])
               (when (and (seq cards)
                          (some (complement :curated) contents))
                 (widgets/edit-pencil
                  {:on-click #(routing/set-query! [:edit key] (when-not edit? true))
                   :class (str "margin-left-2 " (when edit? "icon--active"))}))]]})
     cards]))

(v/defview collection
  [{:keys [collection]
    :as props}]
  (let [sections (contents-sections props)
        query (->> sections
                   (map :query)
                   (filter :query/loading?)
                   first)]
    [:div
     {:key "category"}
     [tabs/tab-bar
      {:tabs
       (doall
        (for [k schema/file-collections]
          {:key (name k)
           :href (app-route/file-collection-href k)
           :label (i/get k)}))
       :key "file-category-nav"
       :selected collection}]
     [widgets/graphql-state
      (-> query
          (assoc :absolute? true
                 :bg-color "white")
          (update :style merge {:top "auto"
                                :margin-top -2
                                :height 2}))]
     [h-slider/h-slider
      {:key "category-items"
       :index (collection-index collection)
       :content/key collection
       :content
       [:div.pad-h-3.pad-bottom-3
        (for [section sections]
          [content-grid (merge props section)])]}]]))


(comment

  (s/def :property/proprety-id string?)
  (s/def :content/collection string?)

  (s/def :files/collection
    (s/keys :req-un [:property/property-id
                     :content/collection]))

  (s/def :content/item
    (s/coll :content))

  (s/fdef content-grid
          :args (s/cat :props :files/collection
                       :content :contented/content))

  (s/fdef content-section
          :args (s/merge :files/collection
                         (s/keys :req-un [:section/title])))

  (s/fdef collection
          :args :files/collection))

;; ========== Files Screen ==========

(v/defview collection-picker
  []
  [:div.pad-v-3.pad-h-3
   [:div.pad-h-2.pad-bottom-3
    [:div.text-category.flex.items-center.pad-v-1
     (i/get :i/my-files)]]
   [card/card-grid
    {:key "file-grid"}
    (for [k schema/file-collections]
      (let [label (i/get k)]
        {:key label
         :id label
         :label label
         :href (app-route/file-collection-href k)
         :icon (schema/file-collection-icon k)}))]])

(comment

 (current-property/get-property)

 (all-items (current-property/get-id))

 (q-asset/asset-group {:id "WBL4xueuTtGoXiSIq8sxtg"})

 (js->clj #js {:error (js/Error "test")})

 (routing/path-for [:add/file-by-collection :collection "media"])
 (routing/path-for :router/form-modal nil)

 (collection-content :files/media)

 )
